import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { DetachedRouterOutlet } from '@core/common-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import { HeadingComponent, TabComponent, TabsComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'x-user-requests',
  imports: [
    CommonModule,
    HeadingComponent,
    TranslatePipe,
    TabsComponent,
    TabComponent,
    RouterLink,
    DetachedRouterOutlet,
    RouterLinkActive,
  ],
  templateUrl: './user-requests.component.html',
  styleUrl: './user-requests.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TellentUserRequestsViewComponent {}
